<template>
  <b-container>
    <div class="rent-job-page page">
      <div
        class="rent-job__content page__card page__card--full page__card--no-bg mt-0"
      >
        <div class="rent-job__left">
          <div class="page__header text-left">
            <h2>Confirm and pay</h2>
          </div>
          <pay-form
            :job="job"
            :start-date="startDate"
            :end-date="endDate"
            :price="price"
            @recalculate="onRecalculate"
          />
        </div>
        <div class="rent-job__right">
          <div ref="sticky" class="rent-job__right__border">
            <price-breakdown
              ref="breakdown"
              :job="job"
              :start-date="startDate"
              :end-date="endDate"
              @new-price="setTotal"
            />
          </div>
        </div>
      </div>
    </div>
  </b-container>
</template>
<script>
/**
 * ==================================================================================
 * Rent Tools/Jobs page
 * ==================================================================================
 **/

import { mapState, mapMutations, mapActions } from 'vuex'
import dayjs from 'dayjs'
import Sticky from '@/utils/mixins/sticky'
import PayForm from '@/components/forms/PayForm'
import PriceBreakdown from '@/components/cards/PriceBreakdown'

export default {
  metaInfo: function() {
    return {
      title: 'Rent Tool'
    }
  },
  components: {
    PayForm,
    PriceBreakdown
  },
  mixins: [Sticky],
  computed: {
    ...mapState({
      user: state => state.auth.user,
      job: state => state.job.jobDetails
    }),
    startDate() {
      if (!this.$route.query) return
      return new Date(this.$route.query.startDate)
    },
    endDate() {
      if (!this.$route.query) return
      return new Date(this.$route.query.endDate)
    },

    isValidDate() {
      if (!this.startDate || !this.endDate) return false
      let start = dayjs(this.startDate)
      let end = dayjs(this.endDate)

      return dayjs(end).diff(dayjs(start), 'day') > 0
    }
  },
  data: function() {
    return {
      price: {
        tool_price: 0,
        grand_total: 0
      }
    }
  },
  methods: {
    ...mapActions({
      getJobDetails: 'job/getJobDetails'
    }),
    ...mapMutations({
      clearJobDetails: 'job/clearJobDetails'
    }),

    async fetchJob() {
      if (this.loading) return
      this.loading = true
      await this.getJobDetails({
        id: this.$route.params.id
      })
        .then(() => {
          this.loading = false

          if (!this.isValidDate && this.job) {
            this.$router.replace({
              name: 'job.view-job-page',
              params: {
                id: this.$route.params.id,
                title: this.job.name.replace(/ +/g, '-').toLowerCase()
              }
            })
          }
        })
        .catch(() => {
          this.loading = false
          this.$router.replace({ name: 'page-not-found' })
        })
    },

    onRecalculate(message) {
      this.$refs.breakdown.refresh(message)
    },

    setTotal(price) {
      this.price = price
    }
  },
  created() {
    this.clearJobDetails()
    this.fetchJob()
  }
}
</script>
<style scoped lang="scss">
.rent-job-page {
  margin-top: 50px;

  .page__header {
    padding: 0px 0 35px 0;
  }

  .rent-job__content {
    display: flex;
    flex-direction: row;

    .rent-job__left {
      width: 53.5%;
      margin-right: 4%;
    }

    .rent-job__right {
      flex-grow: 1;
      padding-top: 30px;

      &__border {
        > * {
          margin-bottom: 17.5px;
        }
      }

      .price-breakdown {
        max-width: 600px;
      }
    }
  }
}

@media (max-width: 768px) {
  .rent-job-page {
    .rent-job__content {
      flex-direction: column;

      .rent-job__left,
      .rent-job__right {
        width: 100%;
        margin-right: 0;
      }

      .rent-job__right {
        .price-breakdown {
          max-width: inherit;
        }
      }
    }
  }
}
</style>
